import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import SetHeader from "../../../_components/_common/Header/SetHeader";
import "./ContactUsArya.css";
import "../AboutA2Z/AboutA2Z.css";

import Subscribe from "../../../_Pages/_webapp/_mainHome/Subscribe";

import WebFooter from "../../../_components/_webapp/Footer/WebFooter";
import N_Contact_Location from "../../../assets/images/N_contact_location.png";
import N_Contact_Email from "../../../assets/images/N_contact_email.png";
import N_Contact_Phone from "../../../assets/images/N_contact_phone.png";
import N_Contact_Fax from "../../../assets/images/N_contact_fax.png";

import { Validation } from "../../../_helpers/validation/Validation";
import { ContactUsService } from "../../../_services/CommnService/ContactUs/ContactUsService";

import LoaderWithLogo from "../../../_components/Loader/LoaderWithLogo";
import toastr from "toastr";

import { GoogleApiWrapper } from "../../../_components/c_package/google-maps-react";

import { CommonVariables } from "../../../_constants/CommonVariables";
import ReCAPTCHA from "react-google-recaptcha";
import ValidationError from "../arya2.0/CommonComponents/ValidationError/ValidationError";
import { captchaKey } from "../../../_constants/Config/AryaConstants";
import { URL_CONFIG } from "../../../_constants/Config/URL_CONFIG";

class OurStory extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      content: "",
      lang: "",
      name: "",
      email: "",
      phone: "",
      message: "",
      isLoading: false,
      error: {},
      captchaToken: "",
      refreshCaptchaKey: 0,
    };
  }

  unsetFormData = () => {
    this.setState({
      content: "",
      lang: "",
      name: "",
      email: "",
      phone: "",
      message: "",
      isLoading: false,
      error: {},
    });
  };

  componentDidMount() {
    window.scrollTo(0, 0);
  }
  handleRefresh = () => {
    this.setState({
      refreshCaptchaKey: this.state.refreshCaptchaKey + 1
    });
  };
  captchChange = (value) => {
    this.setState({ error: { ...this.state.error, ["captchaToken"]: "" } });
    this.setState({ captchaToken: value });
    // setData((prev) => ({ ...prev, ["captchaToken"]: value }));
  };

  onExpired = (value) => {
    this.setState({ captchaToken: "" });
    this.setState({ error: { ...this.state.error, ["captchaToken"]: "" }, captchaToken: "" });

    // setData((prev) => ({ ...prev, ["captchaToken"]: "" }));
  };
  onChange = (e) => {
    this.setState(
      {
        [e.target.name]: e.target.value,
      },
      () => {
        this.setState({
          error: {},
        });
      }
    );
  };

  createFormData() {
    var objdata = {
      first_name: this.state.name,
      last_name: "",
      phone_number: this.state.phone,
      email: this.state.email,
      message: this.state.message,
      location: "",
      landline_number: "",
      type: this.props.type ? this.props.type : 2,
      commodity: "",
      funded_location: "",
      captcha_token: this.state.captchaToken,
    };
    return objdata;
  }

  onSubmit = async (e) => {
    e.preventDefault();
    var errobj = {};
    errobj = Validation(this.state, rules);
    this.setState({ error: errobj, isLoading: true });
    if (!this.state.captchaToken) {
      errobj.captchaToken =
        "Please check the box indicating 'I am not a robot' to submit your application";
    }
    var flag = 0;
    Object.keys(errobj).forEach((index) => {
      if (errobj[index] !== "") {
        flag = 1;
      }
    });

    if (flag === 0) {
      var registerdata = this.createFormData();
      const result = await ContactUsService.contactUs(registerdata);
      if (result.data.status_code === 200) {
        toastr.info("Thank You");
        this.handleRefresh();
        this.unsetFormData();
      } else {
        this.setState({ isLoading: false });
      }
    } else {
      this.setState({
        isLoading: false,
      });
    }
  };

  render() {
    return (
      <React.Fragment>
        <SetHeader active={"story"} history={this.props.history}></SetHeader>
        <LoaderWithLogo isLoading={this.state.isLoading} />
        <section className="Contactbanner"></section>

        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="NA_customBreadcumb">
                <a
                  href="javascript:void(0);"
                  onClick={() => this.props.history.push("/")}
                >
                  Arya.ag
                </a>{" "}
                <span>→</span> <strong> Contact Us</strong>
              </div>
            </div>
          </div>
        </div>

        <section className="NA_about">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="NA_about_heading">
                  <h2>Contact Us</h2>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="N_Contact_form">
          <Container>
            <Row>
              <Col>
                <p>Still have questions? Just fill in the form below</p>
                <div className="N_Form_Address">
                  <div className="N_Contact_Form_left">
                    <form onSubmit={this.onSubmit}>
                      <div className="form-group">
                        <label>Your Name *</label>
                        <input
                          type="text"
                          name="name"
                          onChange={this.onChange}
                          value={this.state.nmae}
                          placeholder="Enter your full name"
                        />
                        {this.state.error && this.state.error.name !== "" && (
                          <div className="fromerror positionUnset">
                            {this.state.error.name}
                          </div>
                        )}
                      </div>
                      <div className="form-group">
                        <label>Your Email *</label>
                        <input
                          type="text"
                          name="email"
                          onChange={this.onChange}
                          value={this.state.email}
                          placeholder="Enter your email address"
                        />
                        {this.state.error && this.state.error.email !== "" && (
                          <div className="fromerror positionUnset">
                            {this.state.error.email}
                          </div>
                        )}
                      </div>
                      <div className="form-group">
                        <label>Your Phone Number *</label>
                        <input
                          type="number"
                          name="phone"
                          onChange={this.onChange}
                          value={this.state.phone}
                          placeholder="Enter your phone number"
                        />
                        {this.state.error && this.state.error.phone !== "" && (
                          <div className="fromerror positionUnset">
                            {this.state.error.phone}
                          </div>
                        )}
                      </div>
                      <div className="form-group">
                        <label>Message</label>
                        <textarea
                          placeholder="Type your message"
                          name="message"
                          value={this.state.message}
                          onChange={this.onChange}
                        ></textarea>
                        {this.state.error &&
                          this.state.error.message !== "" && (
                            <div className="fromerror positionUnset">
                              {this.state.error.message}
                            </div>
                          )}
                      </div>
                      <div className="row mb-4 ml-1">
                        <div className="w-100">
                          <ReCAPTCHA
                            key={this.state.refreshCaptchaKey}
                            sitekey={captchaKey}
                            onChange={this.captchChange}
                            onExpired={this.onExpired}
                          />
                          {this.state.error.captchaToken && (
                            <ValidationError
                              text={this.state.error.captchaToken}
                              showIcon={false}
                              // imageClassName={"mb-auto"}

                              textClassName={"desk-input-error-style"}
                            />
                          )}
                        </div>
                      </div>
                      <button>Submit</button>
                    </form>
                  </div>

                  <div className="N_Contact_Form_right">
                    <h3>Head Office:</h3>
                    <p>Aryatech Platforms Private Limited.</p>
                    <div className="N_Contact_right">
                      <div className="N_Contact_right_section">
                        <div className="N_Contact_right_section_img">
                          <img alt="" src={N_Contact_Location} />
                        </div>
                        <p>
                          H-82, Ground Floor, Sector 63, Noida (UP), Pin -
                          201301
                        </p>
                      </div>
                      <div className="N_Contact_right_section">
                        <div className="N_Contact_right_section_img">
                          <img alt="" src={N_Contact_Email} />
                        </div>
                        <p>
                          <a href={"mailto:" + CommonVariables.arya_email}>
                            {CommonVariables.arya_email}
                          </a>
                        </p>
                      </div>
                      <div className="N_Contact_right_section">
                        <div className="N_Contact_right_section_img">
                          <img alt="" src={N_Contact_Phone} />
                        </div>
                        <p>
                          <a href="tel:+91-120-4859300">+91-120-4859300</a>
                        </p>
                      </div>
                      <div className="N_Contact_right_section">
                        <div className="N_Contact_right_section_img">
                          <img alt="" src={N_Contact_Fax} />
                        </div>
                        <p>
                          <a href="tel:+91-120-4859323">+91-120-4859323</a>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>

          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <div className="ware-location mb-4">
                  <div className="ware-location-title"></div>
                  <div className="ware-location-map"></div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <div class="mapouter">
          <div class="gmap_canvas">
            <iframe
              loading="lazy"
              class="gmap_iframe"
              width="100%"
              height="350px"
              frameborder="0"
              scrolling="no"
              marginheight="0"
              marginwidth="0"
              src="https://maps.google.com/maps?width=794&amp;height=329&amp;hl=en&amp;q=Arya Collateral Warehousing Services Private Limited&amp;t=&amp;z=14&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"
            ></iframe>
          </div>
        </div>
        <section className="N_stay_update">
          <div className="container">
            <div className="row">
              <Subscribe></Subscribe>
            </div>
          </div>
        </section>
        <WebFooter />
      </React.Fragment>
    );
  }
}

const WrappedContainer = GoogleApiWrapper({
  apiKey: URL_CONFIG.GOOGLE_API_KEY,
})(OurStory);

export default WrappedContainer;

const rules = [
  {
    field_name: "name",
    label: "First Name",
    type: "string",
    isRequired: true,
  },
  {
    field_name: "email",
    label: "Email",
    type: "email",
    isRequired: true,
  },
  {
    field_name: "phone",
    label: "Phone number",
    type: "phone",
    // min: 10,
    // max: 13,
    isRequired: true,
  },
  {
    field_name: "message",
    type: "string",
    label: "Message",
    isRequired: true,
  },
];
